import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import revampData from '../../data/revampData.json';
import { websiteColors } from "../../themes/Theme.js";

const RevampTermsAndConditions = () => {
    const termsAndConditionsContent = revampData.data.listTermsConditions.data[0].TermsConditionsBodyHtml;

    return (
        <div style={{
            "--primaryWebsiteTheme": websiteColors.light.primaryWebsiteTheme,
            "--headingColor": websiteColors.light.headingColor,
            "--staticPagesHeading": websiteColors.light.staticPagesHeading,
            "--staticPagesLink": websiteColors.light.staticPagesLink,
            "--staticPagesTableBorder": websiteColors.light.staticPagesTableBorder
        }}>
            <NextSeo {...seoFunct("revampTermsAndConditionsSeo")} />
            <div className="figtree-family" dangerouslySetInnerHTML={{ __html: termsAndConditionsContent }}></div>
        </div>
    );
};

export default withRouter(RevampTermsAndConditions);
